import gql from 'graphql-tag';

import logosPageFragment from '../fragments/logosPageFragment';

export const queryLogosPage = gql`
  query logosPage(
    $count: Int!
    $isReusable: Boolean!
    $offset: Int!
  ) {
    logosPage(
      count: $count
      isReusable: $isReusable
      offset: $offset
    ) {
      ...logosPageFragment
    }
  }
  ${logosPageFragment}
`;
export default queryLogosPage;
